export default __webpack_public_path__ + "static/media/CarImages.K2500Medium1.6d75cbdf.jpg";